module.exports = __webpack_public_path__ + "img/paysafe.ef4236c5.svg";